import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { getYearLabel } from '../../../Common/Util/getYearLabel';
import { useIgdChartsDataContext } from './hooks/useIgdChartsDataContext';

export const RegistrationUpdatesAnual = () => {
    const { chartData } = useIgdChartsDataContext();


    return (
        <SimpleBars
            title={'Taxa de Atualização Cadastral (Anual)'}
            horizontal={false}
            subtitles={chartData?.registrationUpdatesAnual?.map((item) => getYearLabel(item.ano))}
            values={chartData?.registrationUpdatesAnual?.map((item) => item.value  ||  0)}
        />
    );
};
